<ng-container *ngIf="subscriptionInfo">
  <tr *ngFor="let subscription of subscriptionInfo; let i = index">
    <td *ngIf="!isApiRenewalSubscription(subscription)">{{product?.name + ' #' + (i + 1)}}</td>
    <td *ngIf="isApiRenewalSubscription(subscription)" class="api-renew-subs-id">Subscription ID:
      {{subscription?.subscriptionId}}</td>
    <td *ngIf="!isApiRenewalSubscription(subscription)" class="customer-name"
      [ngClass]="{'text-align-center': isOrderConfirmation}">
      {{subscription?.firstName + ' ' + subscription?.lastName}}</td>
    <td class="expiration-date" [ngClass]="{'text-align-center': isOrderConfirmation}">Exp date:
      {{subscription?.subEndDate | date:
      "MM/dd/yyyy"}}</td>
    <td *ngIf="!isOrderConfirmation">
      <a [attr.aria-label]="'checkoutReview.editDeliveryAddressDetails' | cxTranslate"
        [routerLink]="{cxRoute: getCheckoutStepUrl(checkoutStepTypeSubscriptionInformation)} | cxUrl"
        [queryParams]="{index: i, materialNumber: product?.sapMaterialNumber}">
        <div class="edit-icon"></div>
      </a>
    </td>
  </tr>
</ng-container>